// Import Swiper styles
import 'swiper/css';
import { SwiperSlide, Swiper } from 'swiper/react';
import 'swiper/css/autoplay'; // Importation du style pour l'autoplay
import ProjectCard from '../ProjectCard';
import { Autoplay } from 'swiper/modules'; // Importation du module autoplay
import { useMediaQuery } from 'react-responsive';
import { useHover } from "@uidotdev/usehooks";

export default function ProjectCaroussel(
    {
        projects = []
    }
) {
    const isMobile = useMediaQuery(
        {
            query: "(max-width: 600px)"
        }
    )
    const isTablet = useMediaQuery(
        {
            query: "(max-width: 1280px)"
        }
    )

    function getSlidesNumber() {
        if (isMobile) {
            return 1.25;
        } else if (isTablet) {
            return 4;
        } else {
            return 6;
        }
    }

    const [ref, hovering] = useHover();

    return (
        <>
            {!isMobile &&
            <style jsx>{`
                .project-caroussel .swiper-wrapper {
                    transition-timing-function: linear !important; // Applique une transition linéaire aux slides
                }
            `}</style>}

            <div className='w-full project-caroussel' ref={ref}>
                <Swiper
                    slidesPerView={getSlidesNumber()}
                    centeredSlides={true}
                    spaceBetween={30}
                    loop={!isMobile}
                    autoplay={!isMobile && {
                        delay: 0, // Définit le délai à 0 pour un défilement continu
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    }}
                    speed={!isMobile && 2000} // Ajuste la vitesse du défilement continu
                    modules={[Autoplay]}
                    className='w-full max-w-[1920px] mx-auto relative z-1 after:content-[""]'
                >
                    {projects.map((v, index) =>
                        <SwiperSlide key={index}>
                            <ProjectCard {...v} />
                        </SwiperSlide>
                    )}
                    <div className='absolute top-0 left-0 w-full h-full z-10 pointer-events-none mobile:hidden'
                        style={{
                            backgroundImage: 'linear-gradient(to right, white 0%, transparent 10%, transparent 90%, white 100%)',
                        }}></div>
                </Swiper>
            </div>
        </>
    );
}
